import { injectable } from "inversify";
import { AppService, Types } from "../DomainTypes";
import { Catalogue } from "@singularsystems/neo-react-services"
import * as CatalogueRoles from "../Models/Security/CatalogueRoles";
import DataCache from "./DataCache";
import { IGenericApiClient } from "../ApiClients/Catalogues/GenericApiClient";

@injectable()
export default class CatalogueEditService extends Catalogue.CatalogueEditService<DataCache, IGenericApiClient> {

    constructor() {
        super(
            AppService.get(Types.Domain.Services.DataCache),
            AppService.get(Types.Domain.ApiClients.CatalogueGeneric)
        )

        this.makeObservable();
    }

    protected defaultEditRole() { 
        return CatalogueRoles.GenericRoles.Edit;
    }
}